module.exports = __webpack_public_path__ + "static/turf-fertilization.a613630e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/turf-fertilization.jpg
// module id = 482
// module chunks = 213720915766396